import React from "react";
import styled from "styled-components";
import { color, space, typography, shadow } from "styled-system";
import { device } from "../../utils";

const SectionTitle = styled.h2`
  font-weight: 700;
  letter-spacing: -2.5px;
  font-size: 38px;
  @media (max-width: 767px) { font-size: 36px; }
  line-height: 54px;
  margin-bottom: 16px;

  @media ${device.sm} {
    font-size: 48px;
    @media (max-width: 767px) { font-size: 46px; }
    line-height: 62px;
  }

  @media ${device.lg} {
    font-size: 58px;
    line-height: 70px;
    margin-bottom: 30px;
  }

  ${color};
  ${space};
  ${typography};
  ${shadow};
`;

const HeroTitle = styled(SectionTitle)`
  letter-spacing: -2.81px;
  font-size: 48px;
  @media (max-width: 767px) { font-size: 46px; }
  line-height: 56px;
  margin-bottom: 30px;

  @media ${device.sm} {
    font-size: 64px;
    @media (max-width: 767px) { font-size: 62px; }
    line-height: 70px;
  }

  @media ${device.lg} {
    font-size: 74px;
    line-height: 84px;
  }

  @media ${device.xl} {
    font-size: 78px;
    line-height: 84px;
  }
`;

const CardTitle = styled.h4`
  font-size: 19px;
  @media (max-width: 767px) { font-size: 17px; }
  font-weight: 700;
  letter-spacing: -0.66px;
  line-height: 28px;
  ${color};
  ${space};
  ${typography};
  ${shadow};
`;

const Title = ({ variant, ...rest }) => {
  let TitleStyled = SectionTitle;

  switch (variant) {
    case "card":
      TitleStyled = CardTitle;
      break;
    case "hero":
      TitleStyled = HeroTitle;
      break;
    default:
      TitleStyled = SectionTitle;
  }

  return <TitleStyled color="heading" {...rest} />;
};

export default Title;
